export default __webpack_public_path__ + "static/media/008-science.4ac5d624.svg";